<script>
    import TableToggle from "../../../../Components/Common/TableToggle.svelte";
    import {
        CardLayout,
        NotificationModal,
        SvelteTable,
    } from "../../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../../Services/index.svelte";

    import {
        addIcon,
        editIcon,
        deleteIcon,
    } from "../../../../Utils/utilConstants.svelte";

    import {
        changeToSentenceCase,
        getText,
        getEmailValidation,
        getPhoneValidation,
        isObjectEmpty,
        showError,
        showException,
    } from "../../../../Utils/utilFunctions.svelte";

    import {
        addErrorInput,
        removeErrorInput,
    } from "../../helpers/encounterUtils.svelte";

    export let patientContactDetails = {};
    export let patientDetails = {};
    export let patientEncounterDetails = {};
    export let isEditEncounter = false;
    export let patientContactsArr = [];
    export let overrideValidation = false;

    $: isValidEmail = overrideValidation
        ? true
        : patientContactDetails.email
          ? getEmailValidation(patientContactDetails.email)
          : true;

    $: isValidEditContactEmail = overrideValidation
        ? true
        : contactObj.email
          ? getEmailValidation(contactObj.email)
          : true;

    $: isValidPhone = overrideValidation
        ? true
        : patientContactDetails.phone
          ? getPhoneValidation(patientContactDetails.phone)
          : true;

    $: isValidEditContactPhone = overrideValidation
        ? true
        : contactObj.phone
          ? getPhoneValidation(contactObj.phone)
          : true;

    $: isSubmitBtnDisabled =
        !isValidEditContactEmail || !isValidEditContactPhone;

    $: isSelectedObjContactDefault =
        !isObjectEmpty(prevContactObj) && prevContactObj.useAsContact;

    $: if (!isEditEncounter) btnOptions[0].isHidden = true;
    else btnOptions[0].isHidden = false;

    $: isEditEncounter && _getDefaultPatientContact(patientDetails);

    let errInputs = [];

    let isAddContactModalOpen = false,
        isEditContactModalOpen = false,
        isDeleteContactModalOpen = false,
        defaultPatientContact = {},
        __BACKUP_DEFAULT_CONTACT__ = {},
        contactObj = {},
        prevContactObj = {},
        isModifyingContact = false,
        isDefaultContactChanged = false,
        isHandleSetContactDefaultModalOpen = false;

    const btnOptions = [
        {
            iconName: "addIcon",
            hasTooltip: false,
            iFont: addIcon,
            btnText: "Add Contact",
            iconFunction: () => _openCreateContactModal(),
        },
    ];

    const columns = [
        {
            key: "name",
            title: "Name",
            headerClass: "text-left pl-3 cursor-default w-[15%] rounded-tl-xl",
            class: "text-left px-3 cursor-default w-[15%]",
            renderValue: (v) => getText(v.name),
        },
        {
            key: "relationship",
            title: "Relationship",
            headerClass: "text-left pl-3 cursor-default w-[25%]",
            class: "text-left px-3 cursor-default w-[25%]",
            renderValue: (v) => getText(v.relationship),
        },
        {
            key: "email",
            title: "Email",
            headerClass: "text-left pl-3 cursor-default w-[20%]",
            class: "text-left px-3 cursor-default w-[20%]",
            renderValue: (v) => getText(v.email),
        },
        {
            key: "phone",
            title: "Contact No.",
            headerClass: "text-left pl-3 cursor-default w-[15%]",
            class: "text-left px-3 cursor-default w-[15%]",
            renderValue: (v) => getText(v.phone),
        },
        {
            key: "isDefault",
            title: "Default Contact Person",
            headerClass: "text-left pl-3 text-sm cursor-default w-[15%]",
            class: "text-left px-3 cursor-default w-[15%]",
            renderComponent: {
                component: TableToggle,
                props: {
                    valueKey: "useAsContact",
                    disabled: patientEncounterDetails.disableNotifications,
                    clickFunction: async (data) => updateDefaultContact(data),
                },
            },
        },
        {
            key: "buttons",
            title: "",
            headerClass: "text-left pl-3 cursor-default rounded-tr-xl w-[10%]",
            class: "text-left px-3 cursor-default w-[10%]",
            renderValue: (v) => _renderActionIcons(v),
        },
    ];

    export const checkPatientContactValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    export const syncPatientContactDetails = (patientDetails) => {
        const { patientContacts } = patientDetails;

        if (!patientContacts || patientContacts.length === 0)
            patientDetails.patientContacts = [
                {
                    ...patientContactDetails,
                    useAsContact: patientContactDetails.useAsContact
                        ? true
                        : false,
                },
            ];
        else if (patientContactDetails.id) {
            patientDetails.patientContacts = patientContacts.map((contact) => {
                if (contact.id === patientContactDetails.id)
                    return { ...patientContactDetails };
                else return contact;
            });
        } else
            patientDetails.patientContacts = [
                ...patientContacts,
                patientContactDetails,
            ];

        return patientDetails;
    };

    const modifyContact = async (type = "create") => {
        isModifyingContact = true;

        contactObj = {
            ...contactObj,
            patientId: patientDetails.id,
        };

        if (isDefaultContactChanged) {
            await revertDefaultContact();

            if (defaultPatientContact.useAsContact)
                defaultPatientContact.useAsContact = false;
        }

        switch (type) {
            case "create":
                await createContact();
                break;
            case "edit":
                await updateContact();
                break;
            case "delete":
                await deleteContact();
                break;
            default:
                break;
        }

        _closeModifyModal();

        isModifyingContact = false;
    };

    const updateDefaultContact = async (data) => {
        if (!data.id) {
            if (data.useAsContact) return;

            await revertDefaultContact();

            defaultPatientContact.useAsContact = true;

            await reloadPatientContacts();

            return;
        }

        if (data.useAsContact) {
            await revertDefaultContact();

            defaultPatientContact.useAsContact = true;

            await reloadPatientContacts();

            return;
        }

        defaultPatientContact.useAsContact = false;

        await revertDefaultContact();

        contactObj = { ...data, useAsContact: true };

        await updateContact();

        contactObj = {};
    };

    const revertDefaultContact = async () => {
        const defaultContact = patientContactsArr.find(
            (contact) => contact.useAsContact,
        );

        if (defaultContact && defaultContact.id)
            await apiMethods.putMethod.updatePatientContact({
                ...defaultContact,
                useAsContact: false,
            });
    };

    const createContact = async () => {
        await apiMethods.postMethod
            .createPatientContact(contactObj)
            .then((res) => _handleModifyContact(res))
            .catch((err) => showException(err));
    };

    const updateContact = async () => {
        await apiMethods.putMethod
            .updatePatientContact(contactObj)
            .then((res) => _handleModifyContact(res, "update"))
            .catch((err) => showException(err));
    };

    const deleteContact = async () => {
        await apiMethods.deleteMethod
            .deletePatientContact(contactObj.id)
            .then((res) => _handleModifyContact(res, "delete"))
            .catch((err) => showException(err));
    };

    const handleClickCell = ({ target: { className } }, rowData, key) => {
        if (key == "buttons") {
            if (className.includes("editIcon")) _openEditContactModal(rowData);
            else if (className.includes("deleteIcon"))
                _openDeleteContactModal(rowData);
        }
    };

    const reloadPatientContacts = async (resetDefaultContact = true) => {
        await apiMethods.getMethod
            .getPatientById(patientDetails.id)
            .then((res) => {
                const { patientContacts } = res;

                patientContactsArr = patientContacts;
            })
            .catch((err) => showException(err));

        if (resetDefaultContact)
            __BACKUP_DEFAULT_CONTACT__ = patientContactsArr.find(
                (contact) => contact.useAsContact,
            );
    };

    const handleDisableCommunications = async () => {
        if (!isEditEncounter) return;

        if (patientEncounterDetails.disableNotifications) {
            if (__BACKUP_DEFAULT_CONTACT__?.id) await revertDefaultContact();
            else defaultPatientContact.useAsContact = false;
        } else {
            if (__BACKUP_DEFAULT_CONTACT__?.id) {
                contactObj = {
                    ...__BACKUP_DEFAULT_CONTACT__,
                    useAsContact: true,
                };
                await updateContact();
            } else defaultPatientContact.useAsContact = true;
        }

        await reloadPatientContacts(false);
    };

    // HELPER FUNCTIONS
    const _updateInvalidFieldsStyle = () => {
        if (
            !patientContactDetails.name &&
            !patientContactDetails.relationship &&
            !patientContactDetails.email &&
            !patientContactDetails.phone
        ) {
            if (!patientContactDetails.useAsContact) {
                errInputs = removeErrorInput("contactNameInput", errInputs);
                errInputs = removeErrorInput(
                    "contactRelationshipInput",
                    errInputs,
                );
                errInputs = removeErrorInput("contactEmailInput", errInputs);
                errInputs = removeErrorInput("contactPhoneInput", errInputs);
            } else {
                errInputs = addErrorInput("contactNameInput", errInputs);
                errInputs = addErrorInput(
                    "contactRelationshipInput",
                    errInputs,
                );
                errInputs = addErrorInput("contactEmailInput", errInputs);
                errInputs = addErrorInput("contactPhoneInput", errInputs);
            }
            return;
        }

        if (!isValidEmail)
            errInputs = addErrorInput("contactEmailInput", errInputs);

        if (!isValidPhone)
            errInputs = addErrorInput("contactPhoneInput", errInputs);
    };

    const _openCreateContactModal = () => {
        contactObj.useAsContact = _getContactDefaultUse();
        isAddContactModalOpen = true;
    };

    const _openEditContactModal = (obj) => {
        contactObj.useAsContact = _getContactDefaultUse();
        contactObj = { ...obj };
        prevContactObj = { ...contactObj };
        isEditContactModalOpen = true;
    };

    const _openDeleteContactModal = (obj) => {
        contactObj = { ...obj };
        isDeleteContactModalOpen = true;
    };

    const _closeModifyModal = () => {
        isAddContactModalOpen = false;
        isEditContactModalOpen = false;
        isDeleteContactModalOpen = false;
        isDefaultContactChanged = false;
        contactObj = {};
    };

    const _handleModifyContact = (res, type = "create") => {
        if (!res || res.error)
            showError(
                `Failed to ${type} patient contact, please refresh the page and try again and contact support if the issue persists.`,
            );
        else reloadPatientContacts();
    };

    const _handleChangeDefaultContact = () => {
        const alreadyHasDefault = patientContactsArr.some(
            (contact) => contact.useAsContact && contact.id != contactObj.id,
        );

        if (isAddContactModalOpen) {
            if (!alreadyHasDefault) return;
            if (contactObj.useAsContact) _openChangeDefaultContactModal();
        } else if (isEditContactModalOpen) {
            if (!prevContactObj.useAsContact && contactObj.useAsContact)
                _openChangeDefaultContactModal();
        }
    };

    const _openChangeDefaultContactModal = () =>
        (isHandleSetContactDefaultModalOpen = true);

    const _closeChangeDefaultContactModal = (isChange = false) => {
        isDefaultContactChanged = isChange;
        contactObj.useAsContact = isChange;
        isHandleSetContactDefaultModalOpen = false;
    };

    const _getDefaultPatientContact = (patient) => {
        const { firstName, lastName, email, phone, patientContacts } = patient;

        defaultPatientContact = {
            name: `${firstName} ${lastName}`,
            email,
            phone,
            isEditable: false,
            useAsContact: patientContacts?.length
                ? patientContacts.some((contact) => contact.useAsContact)
                    ? false
                    : true
                : true,
        };

        patientContactsArr = patientContactsArr.map((contact) => {
            if (contact.hasOwnProperty("isEditable"))
                return defaultPatientContact;
            else return contact;
        });

        __BACKUP_DEFAULT_CONTACT__ = patientContactsArr.find(
            (contact) => contact.useAsContact,
        );
    };

    const _renderActionIcons = (contact) => {
        const { useAsContact, id, isEditable } = contact;

        if (!id && !isEditable) return "";

        return `<div class="flex flex-1 items-center justify-end gap-x-2">
                    <div class="editIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] cursor-pointer hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Edit Contact">
                        <i class="editIcon ${editIcon}"></i>
                    </div>
                    ${
                        useAsContact
                            ? ""
                            : `<div class="deleteIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] cursor-pointer hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Delete Contact">
                        <i class="deleteIcon ${deleteIcon}"></i>
                    </div>`
                    }
                </div>`;
    };

    const _getContactDefaultUse = () => {
        const isNewObj = !contactObj.hasOwnProperty("id");

        if (!isNewObj) return contactObj.useAsContact;

        if (!patientContactsArr.length) return true;
    };
</script>

<CardLayout title="Contact person" headerClass="card-layout-empty-header" cardClass="!border-0 pl-4 pr-4" {btnOptions} enableCollapse={false}>
    <div class="flex flex-1 flex-col gap-y-4">
        {#if !isEditEncounter}
            <div class="flex flex-1 w-full gap-x-4">
                <div class="flex flex-1 flex-col gap-y-4">
                    <input
                        type="text"
                        id="contactNameInput"
                        placeholder="Contact Name"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={patientContactDetails.name}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Contact Name";
                        }}
                        on:focusout={() => {
                            patientContactDetails.name = changeToSentenceCase(
                                patientContactDetails.name,
                            );
                        }}
                    />

                    <div class="flex flex-col flex-1 gap-y-2">
                        <input
                            type="text"
                            id="contactEmailInput"
                            placeholder="Contact person's email"
                            class="input w-full input-sm input-bordered"
                            autocomplete="off"
                            bind:value={patientContactDetails.email}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder = "Contact person's email";
                            }}
                        />

                        {#if !isValidEmail}
                            <p class="text-error">Invalid Email</p>
                        {/if}
                    </div>

                    <div
                        class="form-control items-center flex flex-row gap-x-4"
                    >
                        <input
                            type="checkbox"
                            id="useAsContactCheckbox"
                            class="toggle toggle-secondary"
                            autocomplete="off"
                            bind:checked={patientContactDetails.useAsContact}
                        />
                        <label
                            for="useAsContactCheckbox"
                            class="cursor-pointer"
                        >
                            Use contact person for communications
                        </label>
                    </div>
                </div>

                <div class="divider divider-horizontal" />

                <div class="flex flex-1 flex-col gap-y-4">
                    <input
                        type="text"
                        id="contactRelationshipInput"
                        placeholder="Relationship"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={patientContactDetails.relationship}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Relationship";
                        }}
                    />

                    <div class="flex flex-col flex-1 gap-y-2">
                        <input
                            type="text"
                            id="contactPhoneInput"
                            placeholder="Contact person's phone"
                            class="input w-full input-sm input-bordered"
                            autocomplete="off"
                            bind:value={patientContactDetails.phone}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder = "Contact person's phone";
                            }}
                            on:blur={() =>
                                (patientContactDetails.phone =
                                    patientContactDetails.phone?.replaceAll(
                                        " ",
                                        "",
                                    ))}
                        />

                        {#if !isValidPhone}
                            <p class="text-error">Invalid Phone</p>
                        {/if}
                    </div>
                </div>
            </div>
        {:else}
            <div
                class="flex flex-1 w-full border border-2 rounded-lg leading-8 min-h-8"
            >
                {#if patientContactsArr.length}
                    <SvelteTable
                        {columns}
                        rows={patientContactsArr}
                        clickCellFunc={({ detail: { event, row, key } }) => {
                            handleClickCell(event, row, key);
                        }}
                    />
                {:else}
                    <p class="px-4 py-2">
                        No contact person currently under this patient
                    </p>
                {/if}
            </div>
        {/if}

        <div class="form-control items-center flex flex-row gap-x-4">
            <input
                type="checkbox"
                id="disableNotifications"
                class="toggle toggle-secondary"
                autocomplete="off"
                bind:checked={patientEncounterDetails.disableNotifications}
                on:change={handleDisableCommunications}
            />
            <label for="disableNotifications" class="cursor-pointer">
                Disable communications
            </label>
        </div>
    </div>
</CardLayout>

<NotificationModal
    isModalOpen={isAddContactModalOpen || isEditContactModalOpen}
    title={`${isAddContactModalOpen ? "Add" : "Edit"} Patient Contact`}
    closeModal={_closeModifyModal}
    cancelText="Cancel"
    isConfirming={isModifyingContact}
    showConfirmBtn={false}
    closeModalFunction={_closeModifyModal}
    noContentPadding
    btnOptions={[
        {
            text: isModifyingContact
                ? "Confirming"
                : isAddContactModalOpen
                  ? "Create"
                  : "Update",
            loading: isModifyingContact || isSubmitBtnDisabled,
            function: () =>
                modifyContact(isAddContactModalOpen ? "create" : "edit"),
        },
    ]}
>
    <div class="flex flex-col w-full gap-y-2 overflow-y-auto p-6">
        <div class="flex gap-x-4">
            <p class="w-36">Name:</p>
            <input
                type="text"
                class="input input-sm input-bordered flex-1"
                autocomplete="off"
                bind:value={contactObj.name}
            />
        </div>

        <div class="flex gap-x-4">
            <p class="w-36">Relationship:</p>
            <input
                type="text"
                class="input input-sm input-bordered flex-1"
                autocomplete="off"
                bind:value={contactObj.relationship}
            />
        </div>

        <div class="flex gap-x-4">
            <p class="w-36">Email:</p>
            <input
                type="email"
                class="input input-sm input-bordered flex-1"
                autocomplete="off"
                bind:value={contactObj.email}
            />
        </div>

        {#if !isValidEditContactEmail}
            <div class="flex gap-x-4">
                <p class="w-36" />
                <p class="text-error">Invalid Email</p>
            </div>
        {/if}

        <div class="flex gap-x-4">
            <p class="w-36">Phone:</p>
            <input
                type="text"
                class="input input-sm input-bordered flex-1"
                autocomplete="off"
                bind:value={contactObj.phone}
                on:blur={() =>
                    (contactObj.phone = contactObj.phone?.replaceAll(" ", ""))}
            />
        </div>

        {#if !isValidEditContactPhone}
            <div class="flex gap-x-4">
                <p class="w-36" />
                <p class="text-error">Invalid Phone</p>
            </div>
        {/if}

        <div class="flex gap-x-4">
            <p class="w-48">Use for communications:</p>
            <input
                type="checkbox"
                class="toggle toggle-secondary"
                bind:checked={contactObj.useAsContact}
                on:change={_handleChangeDefaultContact}
                disabled={isSelectedObjContactDefault ||
                    patientEncounterDetails.disableNotifications}
            />
        </div>
    </div>
</NotificationModal>

<NotificationModal
    isModalOpen={isDeleteContactModalOpen}
    title="Delete patient contact"
    cancelText="Delete"
    submitText="Cancel"
    isReverseBtns={true}
    confirmAction={_closeModifyModal}
    closeModal={() => modifyContact("delete")}
    isConfirming={isModifyingContact}
    closeModalFunction={_closeModifyModal}
>
    Delete patient contact details?
</NotificationModal>

<NotificationModal
    isModalOpen={isHandleSetContactDefaultModalOpen}
    title="Default contact already set"
    cancelText="Cancel"
    closeModalFunction={() => _closeChangeDefaultContactModal(false)}
    confirmAction={() => _closeChangeDefaultContactModal(true)}
    closeModal={() => _closeChangeDefaultContactModal(false)}
>
    This patient already has a default contact, do you want to replace with this
    one?
</NotificationModal>
